const quizData = [
	{
		id: 1,
		Title: "Quiz 1",
		Description: "This quiz is about Geography.",
		Questions: [
			{
				Question: "What is the capital of Australia?",
				Answer: ["Sydney", "Canberra", "Melbourne", "Brisbane"],
				CorrectAnswer: 1,
			},
			{
				Question:
					"Which planet in our solar system is closest to the sun?",
				Answer: ["Mercury", "Mars", "Venus", "Sun"],
				CorrectAnswer: 0,
			},
			{
				Question:
					"Which of the three banks will be merged with the other two to create India’s third-largest bank?",
				Answer: [
					"Punjab National Bank",
					"Indian Bank",
					"Bank of Baroda ",
					"Dena Bank",
				],
				CorrectAnswer: 1,
			},
			{
				Question:
					"What is the name of the weak zone of the earth’s crust?",
				Answer: ["Seismic", "Cosmic", "Formic ", "Anaemic"],
				CorrectAnswer: 0,
			},
			{
				Question:
					"Which of the following organizations creates the topographical maps of India ?",
				Answer: [
					"Geological survey of India",
					"Survey of India",
					"Geographical survey of India",
					"None of Them",
				],
				CorrectAnswer: 1,
			},
			{
				Question:
					"India’s first Uranium Mine is located at which among the following places?",
				Answer: ["Jadugauda", "Tummalapalle", "Pichli", "Dalbhum"],
				CorrectAnswer: 0,
			},
			{
				Question:
					"What fraction of Peninsular India is covered with the Archaean Rocks?",
				Answer: ["1/2", "1/3", "2/3", "2/5"],
				CorrectAnswer: 2,
			},
			{
				Question:
					"The word “Mangal” is used for which among the following kinds of vegetations?",
				Answer: [
					"Aquatic Plants",
					"Algal Blooms",
					"Mangroves",
					"Mediterranean forests, woodlands, and scrub",
				],
				CorrectAnswer: 2,
			},
			{
				Question:
					"Arid Forest Research Institute is located in which state?",
				Answer: ["Rajasthan", "Haryana", "Punjab", "Kerala"],
				CorrectAnswer: 0,
			},
			{
				Question:
					"Which of the following rivers does NOT flow into the Arabian Sea?",
				Answer: ["Tungabhadra", "Sabarmati", "Mandovi", "Narmada"],
				CorrectAnswer: 0,
			},
		],
	},
	{
		id: 2,
		Title: "Quiz 2",
		Description:
			"This is the second Quiz. It contains questions about planets and their properties.",
		Questions: [
			{
				Question: "How many moons does Jupiter have?",
				Answer: ["12", "53", "79", "31"],
				CorrectAnswer: 2,
			},
			{
				Question: "Which is the largest planet in our solar system?",
				Answer: ["Jupiter", "Saturn", "Earth", "Mars"],
				CorrectAnswer: 0,
			},
			{
				Question: "Which is the brightest planet in the universe?",
				Answer: ["Mercury", "Venus", "Earth", "Saturn"],
				CorrectAnswer: 1,
			},
			{
				Question: "Which is the nearest planet to the sun?",
				Answer: ["Neptune", "Mars", "Mercury", "Earth"],
				CorrectAnswer: 2,
			},
			{
				Question: "On which planet the life exists?",
				Answer: ["Earth", "Moon", "Jupiter", "None"],
				CorrectAnswer: 0,
			},
			{
				Question: "Which planet appears to be yellowish?",
				Answer: ["Asteroids", "Mars", "Uranus", "Saturn"],
				CorrectAnswer: 3,
			},
			{
				Question: "Which is the farthest planet of solar system?",
				Answer: ["Neptune", "Jupiter", "Mercury", "Earth"],
				CorrectAnswer: 0,
			},
			{
				Question: "The first outside orbit of the earth planet is",
				Answer: ["Jupiter", "Mars", "Saturn", "Uranus"],
				CorrectAnswer: 1,
			},
			{
				Question: "Which is the largest planet in solar system?",
				Answer: ["Mercury", "Mars", "Jupiter", "Saturn"],
				CorrectAnswer: 2,
			},
			{
				Question: "Stars appear to move from",
				Answer: [
					"West to east",
					"East to west",
					"North to south",
					"South to west",
				],
				CorrectAnswer: 0,
			},
		],
	},
	{
		id: 3,
		Title: "Quiz 3",
		Description: "Another quiz with miscellaneous questions.",
		Questions: [
			{
				Question: "What is the capital of Japan?",
				Answer: ["Tokyo", "Seoul", "Beijing", "Bangkok"],
				CorrectAnswer: 0,
			},
			{
				Question: "Who developed the theory of relativity?",
				Answer: [
					"Isaac Newton",
					"Albert Einstein",
					"Galileo Galilei",
					"Stephen Hawking",
				],
				CorrectAnswer: 1,
			},
			{
				Question: "Which river is the longest in the world?",
				Answer: ["Amazon", "Nile", "Yangtze", "Mississippi"],
				CorrectAnswer: 1,
			},
			{
				Question: "In which year did World War II end?",
				Answer: ["1943", "1945", "1947", "1950"],
				CorrectAnswer: 1,
			},
			{
				Question: "Who painted the Mona Lisa?",
				Answer: [
					"Leonardo da Vinci",
					"Vincent van Gogh",
					"Pablo Picasso",
					"Claude Monet",
				],
				CorrectAnswer: 0,
			},
			{
				Question: "What is the currency of Canada?",
				Answer: ["Euro", "Dollar", "Pound", "Canadian Dollar"],
				CorrectAnswer: 3,
			},
			{
				Question:
					"Which gas makes up the majority of the Earth's atmosphere?",
				Answer: ["Oxygen", "Nitrogen", "Carbon Dioxide", "Helium"],
				CorrectAnswer: 1,
			},
			{
				Question: "Which planet is known as the Red Planet?",
				Answer: ["Venus", "Mars", "Jupiter", "Saturn"],
				CorrectAnswer: 1,
			},
			{
				Question: "Who wrote 'Romeo and Juliet'?",
				Answer: [
					"Charles Dickens",
					"William Shakespeare",
					"Jane Austen",
					"Mark Twain",
				],
				CorrectAnswer: 1,
			},
			{
				Question: "What is the largest mammal in the world?",
				Answer: ["Elephant", "Blue Whale", "Giraffe", "Hippopotamus"],
				CorrectAnswer: 1,
			},
		],
	},
];

export default quizData;
